import { useState } from "react";
import FilterItem from "../../../components/common/FilterItem";
import Modal from "../../../components/common/Modal";

import TableControls from "./../../../components/common/TableControls";
import TableSize from "./../../../components/common/TableSize";
import TextboxSearch from "./../../../components/common/TextboxSearch";
import TaxIndexesFilter from "./TaxIndexesFilter";

const TaxIndexesHeader = ({ options, onChange }) => {
  const [showFilter, setShowFilter] = useState(false);

  const settings = [
    {
      id: 1,
      content: (
        <TableSize size={options.size} onChange={(e) => handleSizeChange(e)} />
      ),
    },
  ];

  const handleSizeChange = (event) => {
    const size = event.target.value;

    if (size !== options.size) {
      const new_options = { ...options };
      new_options.size = size;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleSearch = (query) => {
    const new_options = { ...options };

    if (new_options.search_query !== query) {
      new_options.tax_type = "";
      new_options.year = "";
      new_options.period = "";
      new_options.status = "";
      new_options.search_query = query;
      new_options.current_page = 1;
      onChange(new_options);
    }
  };

  const handleFilter = (tax_type, year, period, status) => {
    const new_options = { ...options };
    new_options.tax_type = tax_type;
    new_options.year = year;
    new_options.period = period;
    new_options.status = status;

    onChange(new_options);
    setShowFilter(false);
  };

  const handleRemoveFilter = (item) => {
    const new_options = { ...options };

    if (item === 1) new_options["tax_type"] = "";
    if (item === 2) new_options["year"] = "";
    if (item === 3) new_options["period"] = "";
    if (item === 4) new_options["status"] = "";

    onChange(new_options);
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500">Tax Index</p>
          <span className="text-gray-400 text-sm">Tax Deadlines</span>
        </div>
        <div className="mt-5 lg:mt-0 block md:flex md:space-x-2">
          <TextboxSearch placeholder="Search..." onSearch={handleSearch} />
          <TableControls
            onFilter={() => setShowFilter(true)}
            settings={settings}
          />
        </div>
      </div>
      <div className="mt-2 float-right">
        <div className="flex gap-2">
          {options.tax_type !== "" && options.tax_type !== undefined && (
            <FilterItem
              title={options.tax_type.label}
              onRemove={() => handleRemoveFilter(1)}
            />
          )}
          {options.year !== "" && options.year !== undefined && (
            <FilterItem
              title={options.year}
              onRemove={() => handleRemoveFilter(2)}
            />
          )}
          {options.period !== "" && options.period !== undefined && (
            <FilterItem
              title={options.period.label}
              onRemove={() => handleRemoveFilter(3)}
            />
          )}
          {options.status !== "" && options.status !== undefined && (
            <FilterItem
              title={options.status.label}
              onRemove={() => handleRemoveFilter(4)}
            />
          )}
        </div>
      </div>
      <Modal
        borderTop
        title="Filter"
        isOpen={showFilter}
        onClose={() => setShowFilter(false)}
        children={
          <TaxIndexesFilter options={options} onFilter={handleFilter} />
        }
      />
    </>
  );
};

export default TaxIndexesHeader;
